module.exports = __webpack_public_path__ + "media/components/Application/Influencers/Index/fv_image_sp-79dc6a6b13847a9d47fc5a8e9b8be2c4.png";